export default __webpack_public_path__ + "static/media/goOut.37210172.mp3";